class ActivityRpcDTO {
  /** backgroundColor */
  backgroundColor = '';

  /** beginTime */
  beginTime = '';

  /** content */
  content = '';

  /** contentColor */
  contentColor = '';

  /** endTime */
  endTime = '';

  /** icon */
  icon = '';

  /** id */
  id = undefined;

  /** name */
  name = '';

  /** priorityLevel */
  priorityLevel = undefined;

  /** status */
  status = undefined;

  /** storeCodes */
  storeCodes = [];

  /** url */
  url = '';

  /** urlColor */
  urlColor = '';

  /** urlText */
  urlText = '';
}

class AfterSaleAddressStoreVO {
  /** 区域id */
  area = undefined;

  /** 城市id */
  city = undefined;

  /** 是否含有售后网点 含有:true 不含有:false */
  hasContainStores = false;

  /** 省份id */
  province = undefined;
}

class AfterSaleServiceInfoVO {
  /** 页面内容 */
  pageContent = [];

  /** 页面类型 */
  pageType = undefined;

  /** 页面类型名称 */
  pageTypeName = '';
}

class AfterSaleServiceSubInfoVO {
  /** 图片url */
  picUrl = [];

  /** 标题名称 */
  titleName = '';
}

class AfterSaleStoreDetail {
  /** 售后网点详细地址 */
  address = '';

  /** 区域名称 */
  areaName = '';

  /** 售后网点结束时间 */
  businessHoursEnd = '';

  /** 售后网点开始时间 */
  businessHoursStart = '';

  /** 城市名称 */
  cityName = '';

  /** 距离 */
  distance = '';

  /** 售后网点指引描述 */
  guideText = '';

  /** 售后网点指引url */
  guideUrl = [];

  /** id */
  id = '';

  /** 是否展示联系方式 0:展示 1:不展示 */
  isShowContact = undefined;

  /** 纬度 */
  lat = undefined;

  /** 经度 */
  lon = undefined;

  /** 售后网点名称 */
  name = '';

  /** 省份名称 */
  provinceName = '';

  /** 售后网点类型 0:联保优选 1:第三方售后网点 */
  storeType = undefined;
}

class AfterSaleStoreInfoDTO {
  /** createBy */
  createBy = '';

  /** createTime */
  createTime = '';

  /** id */
  id = '';

  /** pageType */
  pageType = undefined;

  /** picUrl */
  picUrl = [];

  /** sort */
  sort = undefined;

  /** titleName */
  titleName = '';

  /** updateBy */
  updateBy = '';

  /** updateTime */
  updateTime = '';
}

class AfterSaleStoreQueryVO {
  /** 区域id */
  area = undefined;

  /** 城市id */
  city = undefined;

  /** 纬度 */
  lat = undefined;

  /** 经度 */
  lon = undefined;

  /** 页面起始页 */
  page = undefined;

  /** 页面大小,默认为20 */
  pageSize = undefined;

  /** 省份id */
  province = undefined;

  /** 售后网点类型 0:联保优选 1:第三方售后网点 */
  storeType = [];
}

class AfterSaleStoreVO {
  /** 售后网点详细地址 */
  address = '';

  /** 区域名称 */
  areaName = '';

  /** 售后网点结束时间 */
  businessHoursEnd = '';

  /** 售后网点开始时间 */
  businessHoursStart = '';

  /** 城市名称 */
  cityName = '';

  /** 距离 */
  distance = '';

  /** id */
  id = '';

  /** 是否展示联系方式 0:展示 1:不展示 */
  isShowContact = undefined;

  /** 纬度 */
  lat = undefined;

  /** 经度 */
  lon = undefined;

  /** 售后网点名称 */
  name = '';

  /** 省份名称 */
  provinceName = '';

  /** 售后网点类型 0:联保优选 1:第三方售后网点 */
  storeType = undefined;
}

class AreaBigRpcDTO {
  /** areas */
  areas = [];

  /** id */
  id = undefined;

  /** name */
  name = '';

  /** uniqueCode */
  uniqueCode = '';
}

class ConfigResponse {
  /** 配置明细 */
  configs = [];
}

class CoordinateDTO {
  /** city */
  city = '';

  /** district */
  district = '';

  /** latitude */
  latitude = '';

  /** longitude */
  longitude = '';

  /** province */
  province = '';
}

class ExclusiveConsultantInfoParam {
  /** 年龄范围 1：18-25  2：25-35  3：35+ */
  age_range = undefined;

  /** '预算范围最大值 */
  budget_max = undefined;

  /** '预算范围最小值 */
  budget_min = undefined;

  /** 喜欢的颜色：1.阳光暖色 2：时尚冷色 3：潮流渐变 */
  colour = undefined;

  /** 更多需要  List  1：震动提醒 2：蓝牙追踪 3：无线充电 4：电量实时掌握 */
  other_need = [];

  /** 性别  1:男  2:女 */
  sex = undefined;

  /** 风格 1：酷炫科技 2：潮流达人 3：高端商务 4：休闲生活 */
  style = undefined;

  /** 口味 1:薄荷清凉 2：缤纷水果 3：酷爽饮料 4：经典原味 */
  taste = undefined;

  /** 使用人 1.自用 2.送人 */
  user_type = undefined;
}

class GeneralHttpResponse {
  /** code */
  code = undefined;

  /** data */
  data = new ConfigResponse();

  /** msg */
  msg = '';
}

class HttpResponse {
  /** code */
  code = undefined;

  /** data */
  data = undefined;

  /** msg */
  msg = '';
}

class LinkedUrl {
  /** url */
  url = '';
}

class PairEntity {
  /** code */
  code = undefined;

  /** id */
  id = undefined;

  /** message */
  message = '';
}

class PostsInfoVO {
  /** 内容 */
  content = '';

  /** 帖子ID */
  id = undefined;

  /** 帖子图片, 逗号分割 */
  imgUrl = '';

  /** 门店code */
  storeCode = '';

  /** 帖子标题 */
  title = '';

  /** 用户信息VO */
  userNewsVO = new UserNewsVO();

  /** webContent */
  webContent = '';
}

class SimpleActivityVO {
  /** activity_id */
  activity_id = undefined;

  /** activity_name */
  activity_name = '';
}

class SimpleStoreTagEntity {
  /** client_show */
  client_show = undefined;

  /** id */
  id = undefined;

  /** tag_name */
  tag_name = '';

  /** tag_pic_url */
  tag_pic_url = '';
}

class SimpleStoreVO {
  /** distance */
  distance = '';

  /** opening_hour */
  opening_hour = '';

  /** store_addr */
  store_addr = '';

  /** store_code */
  store_code = '';

  /** store_id */
  store_id = undefined;

  /** store_name */
  store_name = '';
}

class SimpleVO {
  /** area_code */
  area_code = undefined;

  /** area_name */
  area_name = '';

  /** distance */
  distance = '';

  /** opening_hour */
  opening_hour = '';

  /** store_addr */
  store_addr = '';

  /** store_code */
  store_code = '';

  /** store_id */
  store_id = undefined;

  /** store_name */
  store_name = '';
}

class StarEnum {
  /** 渠道编码 */
  code = undefined;

  /** 描述 */
  desc = '';

  /** 扩展属性配置 */
  exts = undefined;

  /** goldFilter */
  goldFilter = false;

  /** relx */
  relx = false;

  /** 客服电话 */
  servicePhone = '';

  /** 统一编码 */
  unifiedCode = '';
}

class StoreActivityVO {
  /** 活动详情url */
  activity_detail_url = '';

  /** 活动icon */
  activity_icon = '';

  /** 活动id */
  activity_id = undefined;

  /** 活动名称 */
  activity_name = '';

  /** 活动文字颜色 */
  content_color = '';

  /** 活动名称背景色 */
  name_background_color = '';

  /** priority_level */
  priority_level = undefined;
}

class StoreAreaVO {
  /** id */
  id = undefined;

  /** name */
  name = '';

  /** parent_id */
  parent_id = undefined;
}

class StoreClueDTO {
  /** feedbackTime */
  feedbackTime = '';

  /** storeClue */
  storeClue = '';

  /** storeCode */
  storeCode = '';

  /** storeName */
  storeName = '';
}

class StoreCommonDTO {
  /** headImgUrl */
  headImgUrl = '';

  /** nickName */
  nickName = '';

  /** reviewComment */
  reviewComment = '';

  /** reviewCount */
  reviewCount = undefined;

  /** reviewDate */
  reviewDate = '';

  /** reviewId */
  reviewId = undefined;

  /** reviewPicUrl */
  reviewPicUrl = '';

  /** score */
  score = '';
}

class StoreDetailVO {
  /** 门店打烊时间 */
  closing_time = '';

  /** 来自顾客的真实评价（,分隔） */
  comment_tag = '';

  /** 投诉人数 */
  complaint_numbers = undefined;

  /** 展示微信联系 1：展示 2：不展示 */
  concat_status = undefined;

  /** 距离描述 */
  distance_desc = '';

  /** 门店指引图片 */
  guide_pic_urls = [];

  /** 门店指引 */
  guide_text = '';

  /** 价优之选店？ 0 否 1 是 */
  low_price = undefined;

  /** 门店开始营业时间 */
  opening_time = '';

  /** 推荐人数 */
  recommend_numbers = undefined;

  /** 门店有售 */
  sell_goods_types = [];

  /** 门店参与活动 */
  store_activities = [];

  /** 门店详细地址 */
  store_address = '';

  /** 门店编码 */
  store_code = '';

  /** 门店Id */
  store_id = undefined;

  /** 门店经纬度 */
  store_lng_lat = '';

  /** 门店名称 */
  store_name = '';

  /** 门店点评 */
  store_review = new StoreReviewVO();

  /** 门店服务标签 */
  store_server_labels = [];

  /** 门店星级 */
  store_star_level = '';

  /** 门店二级分类 */
  store_sub_type = undefined;

  /** 门店tag */
  store_tags = [];

  /** 门店类型 */
  store_type = undefined;

  /** 是否显示号码 */
  view_phone = undefined;
}

class StoreFeedback {
  /** 审批状态 1-未发起,2-审批中,3-已通过,2-已驳回 */
  approveStatus = undefined;

  /** 审批次数 */
  approveTimes = undefined;

  /** 是否自动拦截 */
  auto_intercept = undefined;

  /** 烟弹价格 */
  bomb_price = '';

  /** 反馈用户手机号，加密 */
  encrypt_phone = '';

  /** 专属顾问参数 */
  exclusive_consultant_info_param = new ExclusiveConsultantInfoParam();

  /** 反馈内容 此处存储的是客人微信或者手机号 */
  feedback_content = '';

  /** 反馈备注，问题描述 */
  feedback_remark = '';

  /** 反馈类型 1:投诉 2:报错 3:点评 31:点评v4.4版本 4:线索 5:订单 */
  feedback_type = undefined;

  /** 反馈用户id */
  feedback_user_id = undefined;

  /** 反馈用户手机号，use for feedback_type=3 */
  feedback_user_phone = '';

  /** 反馈用户token，use for feedback_type=3 */
  feedback_user_token = '';

  /** 店内货品齐全 */
  goods_complete_star = undefined;

  /** 用户纬度 */
  lat = undefined;

  /** 用户经度 */
  lng = undefined;

  /** localDate */
  localDate = '';

  /** 下单详情 */
  orderDetails = [];

  /** 是否参与计算 */
  participate_count = undefined;

  /** 价格点评 0:价格实惠，低于我的预算 1:价格适中，符合我的预算 2:价格略高，超出我的预算 */
  price_comment = undefined;

  /** 1：悦刻产品2：非悦刻产品0：没有购买 */
  product_source = '';

  /** 店员专业能力 */
  professional_star = undefined;

  /** 优质点评 0-否 1-是 */
  quality_comments = undefined;

  /** 真实消费 0-否 1-是 */
  real_consumption = undefined;

  /** 最近消费金额 */
  recency_amount = undefined;

  /** 最近消费产品 */
  recency_product = '';

  /** 回复内容 */
  replyContent = '';

  /** 回复人 */
  replyUser = '';

  /** 预约结束时间 HH:mm:ss */
  reservationEndTime = '';

  /** 预约开始时间 HH:mm:ss */
  reservationStartTime = '';

  /** 点评评论 */
  review_comment = '';

  /** 烟杆价格 */
  rod_price = '';

  /** 用户来源 0 门店 1 微信推送 */
  source_type = undefined;

  /** 星际化标识  1-悦刻,2-清九野,3-凉露滋,4-野有美 */
  starChannel = undefined;

  /** 服务态度星级 -> 店员服务态度 */
  store_attitude_star = '';

  /** 店员服务态度 */
  store_attitude_star_int = undefined;

  /** 门店环境星级 -> 产品陈列展示 */
  store_env_star = '';

  /** 门店id */
  store_id = undefined;

  /** 门店讲解星级 -> 产品疑问解答 */
  store_introduce_star = '';

  /** 主动介绍会员星级 */
  store_referral_star = '';

  /** 门店试吸体验 */
  tasting_star = undefined;

  /** 0 未使用 1 已使用 */
  used = undefined;

  /** 愿意推荐朋友星级 */
  will_recommend_star = '';

  /** 愿意推荐朋友星级 */
  will_recommend_star_int = undefined;

  /** 工单ID */
  work_order_id = undefined;

  /** 工单编号 */
  work_order_no = '';

  /** 工单同步时间 */
  work_order_sync_time = '';
}

class StoreInfoDTO {
  /** address */
  address = '';

  /** id */
  id = undefined;

  /** name */
  name = '';

  /** phone */
  phone = '';
}

class StoreNearbyBindVO {
  /** 门店数据 */
  list = [];

  /** 0 存在筛选结果, 1 无筛选结果 */
  state = undefined;
}

class StoreNearbyVO {
  /** 烟弹均价 */
  bomb_avg_amount = '';

  /** 门店打烊时间 */
  closing_time = '';

  /** 来自顾客的真实评价（,分隔） */
  comment_tag = '';

  /** 投诉人数 */
  complaint_numbers = undefined;

  /** 展示微信联系 1：展示 2：不展示 */
  concat_status = undefined;

  /** 距离描述 */
  distance_desc = '';

  /** 是否存在门店销售数据？ 0 否 1 是 */
  exists_sale_data = undefined;

  /** 价优之选店？ 0 否 1 是 */
  low_price = undefined;

  /** 门店开始营业时间 */
  opening_time = '';

  /** 推荐人数 */
  recommend_numbers = undefined;

  /** 烟杆均价 */
  rod_avg_amount = '';

  /** 月售 */
  sale_nums = undefined;

  /** 门店参与活动 */
  store_activities = [];

  /** 门店详细地址 */
  store_address = '';

  /** 门店Id */
  store_id = undefined;

  /** 门店经纬度 */
  store_lng_lat = '';

  /** 门店名称 */
  store_name = '';

  /** 门店星级 */
  store_star_level = '';

  /** 门店二级分类 */
  store_sub_type = undefined;

  /** 门店tag */
  store_tags = [];

  /** 门店类型 */
  store_type = undefined;

  /** 是否显示号码 */
  view_phone = undefined;
}

class StoreOrderDetailDTO {
  /** 烟杆名称 */
  pole_name = '';

  /** 口味名称 */
  taste_name = '';

  /** 单位名称 */
  unit_name = '';
}

class StoreReviewVO {
  /** 头像 */
  head_img_url = '';

  /** 昵称 */
  nick_name = '';

  /** 优质点评 0-否 1-是 */
  quality_comments = undefined;

  /** 真实消费 0-否 1-是 */
  real_consumption = undefined;

  /** 回复内容 */
  reply_content = '';

  /** 回复人 */
  reply_user = '';

  /** 点评内容 */
  review_comment = '';

  /** 门店点评总数 */
  review_count = undefined;

  /** 点评日期 */
  review_date = '';

  /** 门店点评ID */
  review_id = undefined;

  /** 点评图片 */
  review_pic_url = '';

  /** 打分 */
  score = '';
}

class StoreReviewVOV2 {
  /** 申诉图片 */
  appeal_images = [];

  /** 申诉原因 */
  appeal_reason = '';

  /** 申诉状态 0-审核中, 1-已通过, 2-已驳回 */
  appeal_status = undefined;

  /** 店内货品齐全 */
  goods_complete_star = undefined;

  /** 是否包含申诉 0-不包含, 1-包含 */
  has_appeal = undefined;

  /** 头像 */
  head_img_url = '';

  /** 昵称 */
  nick_name = '';

  /** 回复时间 */
  operator_time = '';

  /** 店员专业能力 */
  professional_star = undefined;

  /** 优质点评 0-否 1-是 */
  quality_comments = undefined;

  /** 真实消费 0-否 1-是 */
  real_consumption = undefined;

  /** 驳回原因 */
  rejection_reason = '';

  /** 回复内容 */
  reply_content = '';

  /** 回复店主姓名 */
  reply_user = '';

  /** 点评内容 */
  review_comment = '';

  /** 门店点评总数 */
  review_count = undefined;

  /** 点评日期 */
  review_date = '';

  /** 门店点评ID */
  review_id = undefined;

  /** 点评图片 */
  review_pic_url = '';

  /** 打分 */
  score = '';

  /** 店员服务态度 */
  store_attitude_star_int = undefined;

  /** 门店试吸体验 */
  tasting_star = undefined;

  /** 点评版本类型 1:4.3及以下版本 2:4.4及以上版本NPS点评 */
  version_type = undefined;
}

class StoreReviews {
  /** 烟弹价格 */
  bomb_price = '';

  /** 评论内容 */
  content = '';

  /** 反馈用户手机号 */
  feedback_user_phone = '';

  /** 反馈用户token */
  feedback_user_token = '';

  /** 店内货品齐全 */
  goods_complete_star = undefined;

  /** 评论配图 */
  image_url = '';

  /** 价格点评 0:价格实惠，低于我的预算 1:价格适中，符合我的预算 2:价格略高，超出我的预算 */
  price_comment = undefined;

  /** 1：悦刻产品2：非悦刻产品0：没有购买 */
  product_source = '';

  /** 店员专业能力 */
  professional_star = undefined;

  /** 烟杆价格 */
  rod_price = '';

  /** 用户来源 0 门店 1 微信推送 */
  source_type = undefined;

  /** 店员服务态度 */
  store_attitude_star_int = undefined;

  /** 门店id */
  store_id = undefined;

  /** 门店试吸体验 */
  tasting_star = undefined;

  /** 愿意推荐朋友星级 */
  will_recommend_star_int = undefined;
}

class StoreServerLabelVO {
  /** icon_url */
  icon_url = '';

  /** summary */
  summary = '';
}

class SubAreaRpcDTO {
  /** id */
  id = undefined;

  /** name */
  name = '';

  /** subAreas */
  subAreas = [];

  /** uniqueCode */
  uniqueCode = '';
}

class SubConfigResponse {
  /** 配置key */
  configKey = '';

  /** 配置value */
  configValue = '';
}

class TagRpcDTO {
  /** endTime */
  endTime = '';

  /** id */
  id = undefined;

  /** startTime */
  startTime = '';

  /** storeCodes */
  storeCodes = [];

  /** storeRangeType */
  storeRangeType = undefined;

  /** storeSubType */
  storeSubType = undefined;

  /** storeType */
  storeType = undefined;

  /** tagName */
  tagName = '';

  /** tagPicUrl */
  tagPicUrl = '';

  /** tagPriority */
  tagPriority = undefined;
}

class UpdateDingTalkWorkStateRequestDTO {
  /** feedback_id */
  feedback_id = undefined;
}

class UserNewsVO {
  /** 粉丝 */
  fansCount = undefined;

  /** 关注 */
  followCount = undefined;

  /** 用户id */
  id = undefined;

  /** 昵称 */
  nickName = '';

  /** 手机 */
  phone = '';

  /** 头像 */
  photo = '';
}

class UserOrderRecord {
  /** createTime */
  createTime = '';

  /** 描述 */
  describe = '';

  /** 描述编码 */
  describeCode = undefined;

  /** id */
  id = undefined;

  /** 订单号 */
  orderNo = '';

  /** sign */
  sign = '';

  /** 门店编码 */
  storeCode = '';

  /** storeId */
  storeId = undefined;

  /** 时间戳 */
  timestamp = undefined;

  /** 用户手机 */
  userPhone = '';
}

class WrapResponse {
  /** code */
  code = undefined;

  /** data */
  data = new AfterSaleAddressStoreVO();

  /** message */
  message = '';

  /** success */
  success = false;
}

export const store = {
  ActivityRpcDTO,
  AfterSaleAddressStoreVO,
  AfterSaleServiceInfoVO,
  AfterSaleServiceSubInfoVO,
  AfterSaleStoreDetail,
  AfterSaleStoreInfoDTO,
  AfterSaleStoreQueryVO,
  AfterSaleStoreVO,
  AreaBigRpcDTO,
  ConfigResponse,
  CoordinateDTO,
  ExclusiveConsultantInfoParam,
  GeneralHttpResponse,
  HttpResponse,
  LinkedUrl,
  PairEntity,
  PostsInfoVO,
  SimpleActivityVO,
  SimpleStoreTagEntity,
  SimpleStoreVO,
  SimpleVO,
  StarEnum,
  StoreActivityVO,
  StoreAreaVO,
  StoreClueDTO,
  StoreCommonDTO,
  StoreDetailVO,
  StoreFeedback,
  StoreInfoDTO,
  StoreNearbyBindVO,
  StoreNearbyVO,
  StoreOrderDetailDTO,
  StoreReviewVO,
  StoreReviewVOV2,
  StoreReviews,
  StoreServerLabelVO,
  SubAreaRpcDTO,
  SubConfigResponse,
  TagRpcDTO,
  UpdateDingTalkWorkStateRequestDTO,
  UserNewsVO,
  UserOrderRecord,
  WrapResponse,
};
